module.exports = __webpack_public_path__ + "static/media/img-excluir-icon.65726bb9.svg";